import * as React from "react";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkSpacing } from "uitk-react-spacing";
import { useLocalization } from "@shared-ui/localization-context";
import { SimpleContainerToggleState } from "./SimpleContainer";
import { SimpleContainerExpandAllProps } from "./typings";

export const SimpleContainerExpandAll = (props: SimpleContainerExpandAllProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkSpacing margin={{ block: "three" }}>
      <div data-testid={props.collapseAll} id={"expand-collapse-buttons"}>
        <UitkTertiaryButton onClick={props.toggleCollapseAll} value={SimpleContainerToggleState.ALL_EXPANDED}>
          {formatText("simpleContainer.expandAllButton")}
        </UitkTertiaryButton>
        <UitkTertiaryButton onClick={props.toggleCollapseAll} value={SimpleContainerToggleState.ALL_COLLAPSED}>
          {formatText("simpleContainer.collapseAllButton")}
        </UitkTertiaryButton>
      </div>
    </UitkSpacing>
  );
};
